import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import InfoSideBar from "./InfoSideBar";

const useStyles = makeStyles((theme) => ({
  nestList: {
    counterReset: "item",
    display: "inline-block",
  },
  nestListItem: {
    "alignItems": "baseline",
    "&::before": {
      color: theme.palette.primary.main,
      counterIncrement: "item",
      display: "inline-block",
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize,
      marginLeft: "-1em",
      width: "1.5em",
    },
  },
  main: {
    margin: theme.spacing(2, 0),
  },
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
}));
const CautionForInvestor = () => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Grid
        spacing={10}
        container
        direction={fullScreen ? "column-reverse" : "row"}
      >
        <Grid item md={4} xs={12}>
          <Box
            m={fullScreen ? theme.spacing(2, 0) : 0}
            textAlign={fullScreen ? "center" : "left"}
          >
            <InfoSideBar />
          </Box>
        </Grid>
        <Grid item md={8} xs={12}>
          <Box>
            <Box>
              <Typography
                style={{
                  display: "flex",
                  fontWeight: "bold",
                  justifyContent: "center",
                }}
              >
                UPI ID and FAQ
              </Typography>
            </Box>
            <Typography style={{ margin: "20px 0px" }}>
              We are using a validated UPI ID for payment, details are as below:
              <br />
              Store Name: CLSA INDIA PRIVATE LIMITED
              <br />
              Merchant Virtual Address: clsaindia.brk@validhdfc
              <br />
              PG Merchant ID: HDFC000077298707
              <br />
              Merchant Key: 28627670a8f5f89a7ae4817bb88b0238
              <br />
              Merchant Key ID: 6421595
            </Typography>

            <Box>
              <Typography style={{ fontWeight: "bold" }}>
                For FAQ, please refer to below circular Annexure F
              </Typography>
            </Box>

            <Typography color="primary" variant="subtitle2">
              <Link
                underline="always"
                href="uploads/SEBI_Circular_on_UPI_IDs_for_Payment_Collection_from_Investors.pdf"
              >
                SEBI/HO/DEPA-II/DEPA-II_SRG/P/CIR/2025/86 June 11, 2025
              </Link>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default CautionForInvestor;
